import { labelChangeFunction } from './CommonFunction'
import { PDFHeader } from './PDFHeader'

export const PDFTitleDetails = async ({
  pdf,
  pageHeight,
  currentY,
  selectedCourseArr,
  title,
  selectedCategory,
  headerImage,
  chartElement,
  instituteDetails,
  year,
}) => {
  const paddingX = 15 // 🔹 Left & right padding
  const paddingY = 3 // 🔹 Top padding
  const pageWidth = pdf.internal.pageSize.getWidth() + 10
  // * paddingX // Adjust width to consider padding
  const lineHeight = 5 // Line spacing for wrapped text
  //console.log(pageWidth, 'pageWidth')
  currentY += paddingY
  pdf.setFontSize(20)
  pdf.text(title, paddingX, currentY)
  currentY += 10
  pdf.setFontSize(12)

  pdf.setFont('helvetica', 'normal') // Set normal font

  const firstText = `Data below shows the indication of ${labelChangeFunction((selectedCategory || 'PLACEMENT').toUpperCase())} overall for `
  const firstTextWidth = pdf.getTextWidth(firstText)

  pdf.text(firstText, paddingX, currentY)

  pdf.setFont('helvetica', 'bold') // Set bold font for "all degrees"
  const boldText = 'all degrees'
  pdf.text(boldText, paddingX + firstTextWidth, currentY)

  const boldTextWidth = pdf.getTextWidth(boldText)

  pdf.setFont('helvetica', 'normal') // Reset to normal font
  const lastText = ' for the TPO'
  pdf.text(lastText, paddingX + firstTextWidth + boldTextWidth, currentY)

  currentY += 10 // Move to the next line

  const wrapText = async (text, x, y, type) => {
    let lines = pdf.splitTextToSize(text, pageWidth)

    for (const [index, line] of lines.entries()) {
      // If there's not enough space, move to a new page before writing
      if (y + lineHeight >= pageHeight - paddingY) {
        pdf.addPage()
        await PDFHeader({
          pdf,
          headerImage,
          instituteDetails,
          chartElement,
          year,
        })

        y = 50
      }

      pdf.setFontSize(type ? 12 : 10)
      pdf.setFont('helvetica', '', type ? 'bold' : 'normal')

      pdf.text(line.trim(), x, y)
      let a = !type && lines?.length - 1 === index
      y += a ? 10 : type ? 8 : lineHeight // Move cursor down
    }

    return y // Return the last printed Y position
  }

  for (const d of selectedCourseArr || []) {
    currentY = await wrapText(d?.label, paddingX, currentY, true)

    // Additional check after wrapping text
    if (currentY >= pageHeight - paddingY) {
      pdf.addPage()
      await PDFHeader({
        pdf,
        headerImage,
        instituteDetails,
        chartElement,
        year,
      })

      currentY = paddingY + 30
    }

    // Print `joinLabel` values
    if (Array.isArray(d?.joinLabel) && d.joinLabel.length > 0) {
      const joinedText = d.joinLabel.map(r => r.label).join(', ')
      // Check if `joinedText` fits, otherwise split across pages
      currentY = await wrapText(joinedText, paddingX, currentY)
    }
  }

  return currentY
}
